import React, { useLayoutEffect } from "react";
import { useIntl } from "react-intl";

import Headline from "../../Headline/Headline";
import NoteCard from "../../UI/Card/NoteCard";
import Section from "../../UI/Others/Section";
import Balloon from "../../UI/Others/balloon";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeOpen, faHeartbeat, faUsers, faBell, faArrowRight, faQuestion } from "@fortawesome/free-solid-svg-icons";

const SupportCard = (props) => {
    return (
        <div className="d-flex col-xs-12 col-md-6 col-xl-3">
            <div className="card">
                <div className="pt-5 pb-3">
                    <Balloon color={props.colorIcon} icon={props.icon} />
                </div>
                            
                <div className="card-body mt-3">
                    <h4 className="card-title mb-2">{props.title}</h4>
                    <p className="card-text">{props.description}</p>
                </div>
            
                <div className="card-footer text-left">
                    <a className={"btn btn-link text-left btn-link-"+ props.colorIcon}
                    href={props.link}
                    target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faArrowRight} className={"mr-2 icon-" + props.colorIcon} />
                        {props.action}
                    </a>
                </div>
            </div>
        </div>
    );
}

const QuestionCard = (props) => {
    return (
        <div className="d-flex col-md-6">
            <NoteCard title={props.title} icon={faQuestion} colorIcon="pink">
                {props.children}
            </NoteCard>
        </div>
    )
}

const Support = () => {
    const intl = useIntl();

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    const title = intl.messages.supportTitle;
    const subtitle = intl.messages.supportMessage;

    return (
        <div id="support">
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
                <SupportCard
                    title={intl.messages.supportCardTitle1}
                    description={intl.messages.supportCardMsg1}
                    action={intl.messages.supportCardAction1}
                    icon={faEnvelopeOpen}
                    colorIcon="violet"
                    link="mailto:support@openrainbow.com?subject=[RainbowHUB] Developer Support"
                >   
                </SupportCard>

                <SupportCard
                    title={intl.messages.supportCardTitle2}
                    description={intl.messages.supportCardMsg2}
                    action={intl.messages.supportCardAction2}
                    icon={faUsers}
                    colorIcon="orange"
                    link="https://support.openrainbow.com/hc/en-us/community/topics/115000150070"
                >
                </SupportCard>

                <SupportCard
                    title={intl.messages.supportCardTitle3}
                    description={intl.messages.supportCardMsg3}
                    action={intl.messages.supportCardAction3}
                    icon={faBell}
                    colorIcon="sky"
                    link="https://support.openrainbow.com/hc/en-us/sections/201292944-Service-Notifications"
                >
                </SupportCard>

                <SupportCard
                    title={intl.messages.supportCardTitle4}
                    description={intl.messages.supportCardMsg4}
                    action={intl.messages.supportCardAction4}
                    icon={faHeartbeat}
                    colorIcon="green"
                    marge="mt-4"
                    link="https://status.openrainbow.com"
                >
                </SupportCard>
            </div>

            <Section 
                title={intl.messages.fAQTitle} 
                className="bg-pink"
            />
            
            <div className="row">
                <QuestionCard title={intl.messages.fAQCardTitle1} intl>{intl.messages.fAQCardMsg1}</QuestionCard>

                <QuestionCard title={intl.messages.fAQCardTitle2}>{intl.messages.fAQCardMsg2}</QuestionCard>
                    
                <QuestionCard title={intl.messages.fAQCardTitle3}>
                    {intl.formatMessage({ id: "fAQCardMsg3" }, { b: chunks => <b>{chunks}</b>, link: <a href="/login" >{intl.messages.loginButton}</a> })}
                </QuestionCard>   
                
                <QuestionCard title={intl.messages.fAQCardTitle4}>{intl.messages.fAQCardMsg4}</QuestionCard>

                <QuestionCard title={intl.messages.fAQCardTitle5}>{intl.messages.fAQCardMsg5}</QuestionCard>

                <QuestionCard title={intl.messages.fAQCardTitle6}>
                    {intl.formatMessage({ id: "fAQCardMsg6" }, { b: chunks => <b>{chunks}</b>, link: <a href="/pricing" >{intl.messages.menuDocPricing}</a> })}
                </QuestionCard>
            </div>
        </div>
    );
}

export default Support;